import { useEffect, useState } from 'react';

export const useAnimationState = () => {
  // Controls when animations are expanded/collapsed, use for both card and inner card animations.
  const [animationState, setAnimationState] = useState({ expand: true });

  useEffect(() => {
    setAnimationState({ expand: true });
    setTimeout(() => {
      setAnimationState({ expand: false });
    }, 500);
  }, []);

  return { animationState };
};
